/**
 * @file 开始使用页旧文档安装hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useLocation, useRouteMatch} from 'react-router-dom';
import {useCallback, useEffect, useState} from 'react';

import {
    fetchGetOldDocDetail
} from '../../../../api/pages/installApi';

const useOldDocHooks = () => {
    const match = useRouteMatch();
    const location = useLocation();

    // 获取快速安装选择器数据
    const [quickInstallDetail, setQuickInstallDetail] = useState<string>('');
    // 获取快速安装详情数据
    useEffect(() => {
        (async () => {
            if (match.path !== '/install/old') {
                return;
            }
            const res = await fetchGetOldDocDetail()
                .catch(() => {
                    // ignore
                });
            if (res) {
                const data = res.body?.result?.pageData || {};
                const qid = data.quickInstallDetail || {};
                setQuickInstallDetail(qid.detail || '');
            }
        })();
    }, [match.path]);

    // 根据 hash 跳转到锚点位置
    const scrollToAnchor = useCallback(() => {
        const anchorName = location.hash.slice(1);
        if (!anchorName) {
            return;
        }
        const anchorDom = document.getElementById(anchorName)
            || document.querySelector(`a[name="${anchorName}"]`);
        if (anchorDom) {
            anchorDom.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, [location.hash]);
    useEffect(scrollToAnchor, [location.hash, quickInstallDetail, scrollToAnchor]);

    return {
        quickInstallDetail
    };
};

export default useOldDocHooks;
